export default "__VITE_ASSET__eeb2d8ff__"